// next
import { useRouter } from 'next/router';
// hooks
import useOffSetTop from '../../hooks/useOffSetTop';
import useTelaGrande from '../../hooks/useTelaGrande';
// config
import { HEADER } from '../../config';
// components
import Logo from '../../components/Logo';
//
import MenuDesktop from './MenuDesktop';
import MenuMobile from './MenuMobile';
import navConfig from './MenuConfig';

/* ============================================================================
   Cabecalho do site publico (layout `main`) - visual novo (shadcn + Tailwind).

   Substitui `AppBar` + `Toolbar` + `styled` + `cssStyles().bgBlur()` do MUI por
   um <header> fixo. Continua igual: fica fixo no topo, encolhe ao rolar
   (`useOffSetTop` com o mesmo limite `HEADER.MAIN_DESKTOP_HEIGHT`), mostra menu
   horizontal no desktop e botao de gaveta no celular.

   O QUE MUDOU, e por que:

   1. SAIU o botao "Purchase Now" que apontava para
      material-ui.com/store/items/minimal-dashboard e a etiqueta "v4.3.0".
      Sao restos do template Minimal: um anuncio de loja de terceiro dentro do
      produto do cliente, e um numero de versao que era string fixa no codigo
      (nao acompanhava o package.json, logo mentia).

   2. `useResponsive('up','md')` virou `useTelaGrande('(min-width: 900px)')`.
      Mesmo limite de antes (o breakpoint `md` do MUI e 900px), mas sem arrastar o
      tema do MUI so para resolver uma media query. O limite vai explicito no
      argumento porque o default do hook e 1200px.

   3. O prop `isHome` continua sendo repassado (os menus o recebem), mas ele NAO
      pinta mais nada de branco. No template, `/` era uma landing com foto escura
      atras do header, e por isso o menu ficava `common.white`; hoje `/` e apenas
      uma tela de redirecionamento sobre fundo claro - texto branco ali some por
      completo. Cor invisivel e defeito, nao estilo.

   4. A faixa e OPACA quando rolada (`bg-surface`), nao translucida. Os tokens
      --gps-* sao cor completa, nao canais HSL: `bg-surface/80` nao gera regra
      alguma no Tailwind e o resultado seria uma faixa sem fundo, com o texto da
      pagina passando por baixo.
   ============================================================================ */

export default function MainHeader() {
  const isOffset = useOffSetTop(HEADER.MAIN_DESKTOP_HEIGHT);

  const { pathname } = useRouter();

  const isDesktop = useTelaGrande('(min-width: 900px)');

  const isHome = pathname === '/';

  return (
    <header
      className={`fixed left-0 top-0 z-[1100] w-full transition-colors duration-200 ${
        isOffset ? 'border-b border-line bg-surface shadow-card' : 'bg-transparent'
      }`}
    >
      <div
        className="mx-auto flex w-full max-w-[1560px] items-center gap-4 px-4 transition-[height] duration-200 lg:px-6"
        style={{
          height: isOffset || !isDesktop ? HEADER.MOBILE_HEIGHT : HEADER.MAIN_DESKTOP_HEIGHT,
        }}
      >
        {/* O logo recebe tamanho explicito: o default do componente e 80x80, mais
            alto que a propria faixa de 64px do celular - antes ele vazava para
            fora do cabecalho. */}
        <Logo sx={{ width: 44, height: 44 }} />

        <div className="flex-1" />

        {isDesktop && <MenuDesktop isOffset={isOffset} isHome={isHome} navConfig={navConfig} />}

        {!isDesktop && <MenuMobile isOffset={isOffset} isHome={isHome} navConfig={navConfig} />}
      </div>
    </header>
  );
}
